// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { AbstractModuleUi } from './abstract-module.ui';
/**
 * The abstract class that every simple module's UI **HAS TO** extend.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let AbstractSimpleModuleUi = class AbstractSimpleModuleUi extends AbstractModuleUi {
    /**
     * @returns The Vue component that will be used to display the module's content.
     */
    get component() {
        return { template: this.html };
    }
    /**
     * @returns The `module` @Prop converted to the raw HTML.
     */
    get html() {
        let html;
        try {
            html = this.DeMarked.convertObjectsToHTML([this.module]);
            this.onReady();
            return html;
        }
        catch (e) {
            this.onError(e);
            return '';
        }
    }
};
AbstractSimpleModuleUi = __decorate([
    Component({
        inheritAttrs: false
    })
], AbstractSimpleModuleUi);
export { AbstractSimpleModuleUi };
/**
 * `ComponentOptions` that every simple module **HAS TO** extend.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const abstractSimpleModuleUiOptions = {
    template: '<component :is="component" />'
};
